import { ButtonLinkExternal } from "@app/ui/shared/button";
import { CopyTextButton } from "@app/ui/shared/copy";
import { useSecurityControlDetailContext } from "./security-controls-control";

const formatFrameworkList = (frameworks: { displayName: string }[]) => {
  if (frameworks.length === 0) return "All Frameworks";
  return frameworks.map((f) => f.displayName).join(", ");
};

export const SecurityControlDetailsTab = () => {
  const { control } = useSecurityControlDetailContext();
  const { globalControl } = control;

  return (
    <div className="space-y-6">
      <section className="rounded-xl border border-gray-200 bg-white p-5">
        <dl className="grid gap-4 md:grid-cols-2">
          <div>
            <dt className="text-xs font-semibold uppercase text-gray-500">
              Availability
            </dt>
            <dd className="mt-1 text-sm text-gray-700">
              {globalControl.isDedicatedOnly
                ? "This control is available on production environments only."
                : "This control is available on all environments."}
            </dd>
          </div>
          <div>
            <dt className="text-xs font-semibold uppercase text-gray-500">
              Category
            </dt>
            <dd className="mt-1 text-sm text-gray-700">{globalControl.area}</dd>
          </div>
          <div>
            <dt className="text-xs font-semibold uppercase text-gray-500">
              Compliance Frameworks
            </dt>
            <dd className="mt-1 text-sm text-gray-700">
              {formatFrameworkList(globalControl.frameworks)}
            </dd>
          </div>
          <div>
            <dt className="text-xs font-semibold uppercase text-gray-500">
              Implementation
            </dt>
            <dd className="mt-1 text-sm text-gray-700">
              {globalControl.hasRemediation
                ? "Additional steps are required to fully implement this control. Review the implementation guidance for details."
                : "This control is managed by Aptible on your behalf. No further action is required."}
            </dd>
          </div>
          {globalControl.callToAction ? (
            <div className="md:col-span-2">
              <dt className="text-xs font-semibold uppercase text-gray-500">
                Learn More
              </dt>
              <dd className="mt-2">
                <ButtonLinkExternal
                  href={globalControl.callToAction}
                  variant="white"
                  className="w-full"
                >
                  View Documentation
                </ButtonLinkExternal>
              </dd>
            </div>
          ) : null}
        </dl>
      </section>

      {globalControl.detailedDescription ? (
        <section className="rounded-xl border border-gray-200 bg-white p-5">
          <div className="flex items-center gap-2">
            <h3 className="text-base font-semibold text-gray-900">
              Detailed Control Description
            </h3>
            <CopyTextButton
              text={globalControl.detailedDescription}
              label="Copy description"
              successIconOnCopy
            />
          </div>
          <p className="mt-4 whitespace-pre-line text-sm text-gray-700">
            {globalControl.detailedDescription}
          </p>
        </section>
      ) : null}
    </div>
  );
};
